import React from 'react';
import ProjectSidebarComponent from './ProjectSidebarComponent';
import { PageHeader } from '../../components';

const MultiGradeFiltersMgf: React.FC = () => {
  return (
    <>
      <PageHeader title="Multi-Grade Filters (MGF)" breadcrumbs={[{ label: "Projects", path: "/projects" }]} />

      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
        style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
        <div className="container">
          <div className="row g-5">

            <div className="col-lg-8">
              <div className="row g-3 mb-5">
                <div className="col-md-12">
                  <img className="img-fluid" src="img/mgf_final.png" alt="" />
                </div>
                
              </div>
              <h1 className="mb-4">Multi-Grade Filters (MGF)</h1>
              
              <h3 className="mb-4">Overview</h3>
              <p>Multi-Grade Filters (MGFs) are high-efficiency media filtration systems designed to remove suspended solids, turbidity, color, and some organic impurities from raw or pre-treated water. At Wasser Technochem (I) Ltd., our MGFs are integral to industrial and municipal water treatment systems, ensuring consistent filtration and long equipment life downstream.</p>

              <h3 className="mb-4">Applications</h3>
              <p><i className="fa fa-filter text-primary me-2"></i>Pre-treatment for RO/UF/EDI Systems</p>
              <p><i className="fa fa-filter text-primary me-2"></i>Clarified water polishing</p>
              <p><i className="fa fa-filter text-primary me-2"></i>Cooling tower makeup water</p>
              <p><i className="fa fa-filter text-primary me-2"></i>Industrial process water</p>
              <p><i className="fa fa-filter text-primary me-2"></i>Boiler feed pre-filtration</p>
              <p><i className="fa fa-filter text-primary me-2"></i>Municipal drinking water schemes</p>

              <h3 className="mb-4">Our Capabilities</h3>
              <p className="mb-4">WTIL designs and supplies automated and manual MGF units with capacities ranging from 1 m³/hr to over 500 m³/hr, suitable for diverse industry requirements. Key features include:</p>
              
              <h4 className="mb-3">Key Features:</h4>
              <div className="mb-4">
                <h5><i className="fa fa-layer-group text-primary me-2"></i>Layered Filtration Media</h5>
                <p className="ms-4">Typically includes a graded bed of coarse gravel, fine sand, and anthracite for efficient multi-depth filtering.</p>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-tools text-primary me-2"></i>Robust FRP/MS/SS Vessels</h5>
                <p className="ms-4">Corrosion-resistant filter housings tailored to flow, pressure, and space constraints.</p>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-cogs text-primary me-2"></i>Automated Backwash System</h5>
                <p className="ms-4">PLC or timer-based backwashing for consistent filter performance and reduced manual intervention.</p>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-plus-circle text-primary me-2"></i>Optional Dual Media Configuration</h5>
                <p className="ms-4">Added manganese dioxide or activated alumina for iron, color, or fluoride removal.</p>
              </div>

              <h3 className="mb-4">Benefits</h3>
              <p><i className="fa fa-check-circle text-success me-2"></i>High filtration efficiency with low-pressure drop</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Extended life of membranes and resins downstream</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Modular design for quick installation and scalability</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Reduced maintenance with self-cleaning options</p>

              <h3 className="mb-4">Why WTIL?</h3>
              <p><i className="fa fa-star text-warning me-2"></i>Custom designs tailored to raw water characteristics across India</p>
              <p><i className="fa fa-star text-warning me-2"></i>Integration with complete WTP/ETP schemes</p>
              <p><i className="fa fa-star text-warning me-2"></i>Decades of experience in industrial applications</p>
              <p className="mb-5"><i className="fa fa-star text-warning me-2"></i>Backed by in-house O&M and troubleshooting teams</p>
            </div>

            <div className="col-lg-4">
              <ProjectSidebarComponent />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default MultiGradeFiltersMgf;
